import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { AuthState } from "../auth/AuthProvider";
import { VersionBadge } from "../VersionBadge";
import { UpdatePrompt } from "../pwa/UpdatePrompt";

export interface RouterContext {
  auth: AuthState;
}

// The query client is deliberately NOT in the router context: it is created per signed-in
// session inside _authed (keyed by uid + business + site), so it does not exist yet here.
export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      <UpdatePrompt />
      <VersionBadge />
    </>
  ),
});
